import Blog24 from '@carbon/icons-react/es/blog/24';
import CaretDown16 from '@carbon/icons-react/es/caret--down/16';
import { Dropdown } from 'antd';
import React, { FC } from 'react';
import { FormattedMessage } from 'react-intl';
import { Menu } from 'components/atoms/dropdown';
import { useDocuments } from 'components/organisms/document/document-store';
import {
  InsertInfoPanelError,
  InsertInfoPanelDefault,
  InsertInfoPanelSuccess,
  InsertInfoPanelWarning,
} from '../info-panel-tools';
import {
  Icon,
  StyledMenu,
  ToolBtn,
  Btn,
  ToolBtnWrapper,
} from '../styled-components';
import { Tool } from '../topbar/types.d';
import { checkActiveState, checkDefaultEnabled } from '../topbar/utils';

const PanelDropdown = () => {
  return (
    <Icon>
      <Blog24 />
      <CaretDown16 />
    </Icon>
  );
};

export const InsertPanels: FC = () => {
  const [state] = useDocuments();
  const tools = [
    {
      key: 'insertInfoPanel',
      label: 'toolbar.info_panel_info',
      Component: InsertInfoPanelDefault,
      haveItsOwnHandler: true,
    },
    {
      key: 'insertInfoPanel',
      label: 'toolbar.info_panel_success',
      Component: InsertInfoPanelSuccess,
      haveItsOwnHandler: true,
    },
    {
      key: 'insertInfoPanel',
      label: 'toolbar.info_panel_warning',
      Component: InsertInfoPanelWarning,
      haveItsOwnHandler: true,
    },
    {
      key: 'insertInfoPanel',
      label: 'toolbar.info_panel_error',
      Component: InsertInfoPanelError,
      haveItsOwnHandler: true,
    },
  ];

  const InsertSectionsMenu = () => (
    <StyledMenu>
      <Menu.Header>
        <FormattedMessage id="toolbar.panels" />
      </Menu.Header>
      {(tools as Tool[]).map(
        ({ key, Component, data, label, haveItsOwnHandler, keyStroke }) => (
          <Menu.Item key={`${key}-${label}`}>
            <ToolBtn
              commandName={key}
              commandValue={data}
              editor={state.editor}
              label={label}
              hideTooltip
              keyStroke={keyStroke}
              haveItsOwnHandler={haveItsOwnHandler}
              command={state.editor?.commands.get(key)}
              haveActiveState={checkActiveState(key)}
              enabled={checkDefaultEnabled(key)}
            >
              {React.createElement(Component, { editor: state.editor })}
            </ToolBtn>
          </Menu.Item>
        ),
      )}
    </StyledMenu>
  );

  return (
    <Dropdown
      overlay={InsertSectionsMenu}
      trigger={['hover']}
      placement="bottomRight"
    >
      <div>
        <ToolBtnWrapper>
          <Btn type="text" icon={<PanelDropdown />} hideHoverEffect />
        </ToolBtnWrapper>
      </div>
    </Dropdown>
  );
};
